import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';

import { TimetrackModalContainer } from './timetrack-modal/timetrack-modal.container';
import { TimetrackModalComponent } from './timetrack-modal/timetrack-modal.component';
import { TimeLogComponent } from './time-log/time-log.component';
import { MoneyLogContainerComponent } from './money-log/money-log.container';
import { MoneyLogComponent } from './money-log/money-log.component';
import { MileageLogContainerComponent } from './mileage-log/mileage-log.container';
import { MileageLogComponent } from './mileage-log/mileage-log.component';
import { TimeLogContainer } from './time-log/time-log.container';
import { TimeLogTdComponent } from './time-log-td/time-log-td.component';
import { MoneyLogTdComponent } from './money-log-td/money-log-td.component';
import { UgerapportSagerFilterPipe } from './ugerapportSagerFilter.pipe';
import { EmployeesDoneContainerComponent } from './employees-done/employees-done.container';
import { EmployeesDoneComponent } from './employees-done/employees-done.component';
import { TimeLogLinesContainerComponent } from './time-log-lines/time-log-lines.container';
import { TimeLogLinesComponent } from './time-log-lines/time-log-lines.component';

@NgModule({
    declarations: [
        TimetrackModalContainer,
        TimetrackModalComponent,
        TimeLogContainer,
        TimeLogComponent,
        MoneyLogContainerComponent,
        MoneyLogComponent,
        MileageLogContainerComponent,
        MileageLogComponent,
        TimeLogTdComponent,
        MoneyLogTdComponent,
        UgerapportSagerFilterPipe,
        EmployeesDoneContainerComponent,
        EmployeesDoneComponent,
        TimeLogLinesContainerComponent,
        TimeLogLinesComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        ScrollingModule,
        CdkTableModule,
        SharedModule
    ]
})
export class TimetrackModule {}
